import { useState } from "react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { ChartLineUp, CurrencyDollar, UsersThree, Factory, Bank, Coins, Drop, House, ClockCounterClockwise, Percent } from "@phosphor-icons/react";
import CpiReport from "@/pages/CpiReport";
import GdpReport from "@/pages/GdpReport";
import UnemploymentReport from "@/pages/UnemploymentReport";
import PmiReport from "@/pages/PmiReport";
import TreasuryReport from "@/pages/TreasuryReport";
import M2Report from "@/pages/M2Report";
import OilGasReport from "@/pages/OilGasReport";
import RealEstateReport from "@/pages/RealEstateReport";
import HistoricData from "@/pages/HistoricData";
import FedRateReport from "@/pages/FedRateReport";

const SUB_TABS = [
  { key: "fedrate", label: "Fed Rate", icon: Percent, color: "amber" },
  { key: "cpi", label: "CPI Report", icon: ChartLineUp, color: "blue" },
  { key: "gdp", label: "GDP", icon: CurrencyDollar, color: "emerald" },
  { key: "unemployment", label: "Unemployment", icon: UsersThree, color: "red" },
  { key: "pmi", label: "PMI", icon: Factory, color: "violet" },
  { key: "treasury", label: "10Y Treasury", icon: Bank, color: "amber" },
  { key: "m2", label: "M2 Supply", icon: Coins, color: "teal" },
  { key: "oilgas", label: "Oil & Gas", icon: Drop, color: "amber" },
  { key: "realestate", label: "Real Estate", icon: House, color: "amber" },
  { key: "historic", label: "Historic Data", icon: ClockCounterClockwise, color: "amber" },
];

export default function Economics() {
  const [tab, setTab] = useState("fedrate");

  return (
    <div data-testid="economics-page">
      <div className="sticky top-0 z-20 bg-zinc-950/95 backdrop-blur-sm border-b border-zinc-800/60 px-5 pt-4 pb-0">
        <Tabs value={tab} onValueChange={setTab}>
          <div className="overflow-x-auto scrollbar-hide -mx-5 px-5 pb-2">
            <TabsList className="h-9 bg-zinc-900/60 border border-amber-500/30 p-0.5 gap-0.5 inline-flex w-max" data-testid="economics-tabs">
              {SUB_TABS.map(t => {
                const Icon = t.icon;
                return (
                  <TabsTrigger
                    key={t.key}
                    value={t.key}
                    data-testid={`economics-tab-${t.key}`}
                    className="text-[11px] px-3 py-1.5 h-8 gap-1.5 font-medium whitespace-nowrap transition-colors data-[state=active]:bg-amber-500/15 data-[state=active]:text-amber-300 data-[state=active]:shadow-sm data-[state=active]:border data-[state=active]:border-amber-500/40"
                  >
                    <Icon size={13} weight="bold" />
                    {t.label}
                  </TabsTrigger>
                );
              })}
            </TabsList>
          </div>
        </Tabs>
      </div>

      <div data-testid={`economics-content-${tab}`}>
        {tab === "fedrate" && <FedRateReport />}
        {tab === "cpi" && <CpiReport />}
        {tab === "gdp" && <GdpReport />}
        {tab === "unemployment" && <UnemploymentReport />}
        {tab === "pmi" && <PmiReport />}
        {tab === "treasury" && <TreasuryReport />}
        {tab === "m2" && <M2Report />}
        {tab === "oilgas" && <OilGasReport />}
        {tab === "realestate" && <RealEstateReport />}
        {tab === "historic" && <HistoricData />}
      </div>
    </div>
  );
}
